// The reimbursement figure the receipt shows is the PAYOUT owed to the property for the period -
// the same stored monthly Payout that Property Details → Highlights → "Reimbursed <Month>" reads
// (Casa de Helix June 2026 = $2,516.15). The backend resolves it and returns it as
// `reimbursementAmount` together with `payoutComputed`; the FE must not derive, sum, or substitute
// anything else.
//
// It must NEVER fall back to the payments collected in the period ($2,614.87 for that same
// property/month) or to charge recovery - those are different, larger numbers, and showing one of
// them under the word "reimbursement" is the bug this replaced. When the payout is not computed
// yet the tile shows no amount and says so.

/** The reimbursement amount to display, or null when the period's payout is not computed yet. */
export const pickReceiptReimbursement = function () {
  let receipt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const isPayout = Boolean(receipt === null || receipt === void 0 ? void 0 : receipt.payoutComputed) && (receipt === null || receipt === void 0 ? void 0 : receipt.reimbursementAmount) != null;
  return {
    value: isPayout ? receipt.reimbursementAmount : null,
    isPayout
  };
};

/**
 * Collected from residents in the period but not paid out: withheld against outstanding resident
 * balances, plus ledger adjustments. Null until the payout is computed.
 */
export const pickReceiptWithheld = function () {
  let receipt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return receipt !== null && receipt !== void 0 && receipt.payoutComputed && (receipt === null || receipt === void 0 ? void 0 : receipt.withheldOrAdjusted) != null ? receipt.withheldOrAdjusted : null;
};